<ws-ace-card header="User Group Name">
    <ng-container card-body>
        <form>
            <div class="mb-3">
                <label>User Group Name:</label>
                <input type="text"
                       class="form-control"
                       [(ngModel)]="userGroup.name"
                       placeholder="Name"
                       [attr.readonly]="!canEdit"
                       maxlength="50"
                       required
                       autofocus>
            </div>
            <div class="mb-3">
                <label>Description:</label>
                <textarea class="form-control"
                          style="height: 60px;"
                          rows="2"
                          [(ngModel)]="userGroup.description"
                          placeholder="Description"
                          ng-readonly="!canEdit"
                          maxlength="100">
                </textarea>
            </div>
            <div class="mb-3">
                <label>Default Company Permissions:</label>
                <br/>
                <ws-select name="defaultPermissions"
                           [(ngModel)]="selectedDefaultPermissions"
                           [options]="permissionOptions"
                           labelProperty="name"
                           (ngModelChange)="permissionChanged()"
                           [disabled]="!canEdit">
                </ws-select>
            </div>
        </form>
    </ng-container>
</ws-ace-card>

